export const getStoreStyles = () => ({
  storeSettings: {
    '& .alert': {
      alignItems: 'center',
      padding: [4, 16, 4, 12],

      '& .alert-image:before': {
        lineHeight: '32px',
      },

      '& .alert__content': {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center',
      },

      '& .alert__action': {
        marginLeft: 'auto',
        marginTop: 'unset',
      },
    },
  },
  storeSettingsLoading: {
    minHeight: 64, // for spinner
  },
  select_store_link: {
    border: '1px solid #8A8886',
    display: 'inline-block',
    background: '#FFF',
    borderRadius: '2px',
    color: '#323130',
    padding: '2px 20px',
    cursor: 'pointer',
    float: 'right',
  },
  warning_no_store: {
    '& .alert': {
      marginTop: 12,
    },
  },
  errorIcon_no_store: {
    padding: '8px 8px 8px 12px',
  },
  select_store_no_store_message: {
    padding: '8px 8px 8px 0px',
  },
  select: {
    width: '252px',
    height: '32px',
    border: '1px solid #605E5C',
    borderRadius: '2px',
  },
  control_title: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
  },
  control: {
    '&:not(:last-child)': {
      marginBottom: 16,
    },
  },
  title_text: {
    margin: '8px 0 8px 0',
  },
  select_label: {
    marginBottom: '4px',
  },
  storeSelectContent: {
    '& div[role="alert"] .error:first-child': {
      paddingTop: '12px',
    },
  },
});
